module.exports = __webpack_public_path__ + "static/media/galerija_2019 (27).c7eecbf5.jpg";